import React from 'react';
import { FormHelperText, Grid, IconButton } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import FormData from 'form-data';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useSnackbar } from 'notistack';
import { useNavigate } from 'react-router';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import LoginLayout from '../../../features/account/LoginLayout';
import TextField from '../../../components/common/InputField/TextField';
import { useForgotPasswordMutation } from '../../../api/account';
import Loader from '../../../components/portals/Loader';

const ForgotPassword = () => {
    const { enqueueSnackbar } = useSnackbar();
    const navigate = useNavigate();
    const [forgotPassword, { isLoading }] = useForgotPasswordMutation();

    const formik = useFormik({
        initialValues: {
            username: '',
        },
        validationSchema: Yup.object({
            username: Yup.string()
                .transform((value) => value?.trim())
                .max(255)
                .required('User Name/Email ID is required'),
        }),
        onSubmit: async (values, helpers) => {
            try {
                const data = new FormData();
                data.append('u', values.username?.trim());
                const response = await forgotPassword(data).unwrap();
                if (!response) return;
                if (response?.status === 'ERROR') throw new Error(response?.message);
                enqueueSnackbar(response?.message, {
                    variant: 'success',
                });
            } catch (err) {
                if (err?.statusCode === 400) enqueueSnackbar(err?.data?.message, { variant: 'error' });
                else enqueueSnackbar(err?.message || 'Something went wrong!', { variant: 'error' });
            }
        },
    });

    return (
        <>
            <LoginLayout>
                {isLoading && <Loader />}
                <Grid container spacing={2} direction="column">
                    <Grid item py={2}>
                        <IconButton color="primary" onClick={() => navigate('/login')}>
                            <ArrowBackIcon />
                        </IconButton>
                    </Grid>
                    <Grid container direction="column">
                        <Grid item>
                            <TextField
                                autoFocus
                                fullWidth
                                label="User Name/ Email ID"
                                name="username"
                                onChange={formik.handleChange}
                                value={formik.values.username}
                                error={Boolean(formik.touched.username && formik.errors.username)}
                                helperText={formik.touched.username && formik.errors.username}
                            />
                        </Grid>
                        {formik.errors.submit && (
                            <Grid item>
                                <FormHelperText error>{formik.errors.submit}</FormHelperText>
                            </Grid>
                        )}
                        <Grid item py={2}>
                            <LoadingButton variant="contained" color="primary" onClick={formik.handleSubmit} fullWidth>
                                Reset Password
                            </LoadingButton>
                        </Grid>
                    </Grid>
                </Grid>
            </LoginLayout>
        </>
    );
};

export default ForgotPassword;
